import { Locale, supportedLocales } from '@oolio-group/localization';
import * as RNLocalize from 'react-native-localize';
import * as storage from '../storage/interface';
import { Session } from './Session';

export const LOCALE_KEY = 'preferredLocale';
export const SESSION_KEY = 'session';
export const THEME_KEY = 'preferredTheme';
export const ORDER_EVENTS_QUEUE_KEY = 'eventsQueue';
export const ENABLE_LOCAL_COMMS = 'enableLocalComms';
export const PAIRING_STEP_KEY = 'deviceSelectionStep';

const availableLocales = Object.keys(supportedLocales);

export async function getLocale(): Promise<Locale | undefined> {
  try {
    const savedLocale = await storage.getItem<Locale>(LOCALE_KEY);

    if (savedLocale && savedLocale.languageTag) {
      return savedLocale;
    }

    const devicePreference =
      RNLocalize.findBestLanguageTag(availableLocales);

    return devicePreference as unknown as Locale;
  } catch (e) {}

  return undefined;
}

export async function setLocale(locale: Locale) {
  try {
    storage.setItem(LOCALE_KEY, locale);
  } catch (e) {}
}

export async function getSession(): Promise<Session | undefined> {
  try {
    const session = await storage.getItem<Session>(SESSION_KEY);

    return session || { authorized: false };
  } catch (e) {}

  return undefined;
}

export async function setSession(data: Session) {
  try {
    await storage.setItem(SESSION_KEY, data);
  } catch (e) {}
}

export async function getTheme(): Promise<string | undefined> {
  try {
    return await storage.getItem<string>(THEME_KEY);
  } catch (e) {}

  return undefined;
}

export async function setTheme(data: string) {
  try {
    storage.setItem(THEME_KEY, data);
  } catch (e) {}
}

export async function getEnableLocalComms(): Promise<boolean | undefined> {
  try {
    return await storage.getItem<boolean>(ENABLE_LOCAL_COMMS);
  } catch (e) {}

  return false;
}

export async function setEnableLocalComms(data: boolean) {
  try {
    await storage.setItem(ENABLE_LOCAL_COMMS, data);
  } catch (e) {}
}

export async function getPairingStep(): Promise<string | undefined> {
  try {
    return await storage.getItem<string>(PAIRING_STEP_KEY);
  } catch (e) {}

  return undefined;
}

export async function setPairingStep(data: string | undefined) {
  try {
    if (data === undefined) {
      await storage.removeItem(PAIRING_STEP_KEY);
    } else {
      await storage.setItem(PAIRING_STEP_KEY, data);
    }
  } catch (e) {}
}
